import { RequireItemList } from '@Src/_basic/object/TestInDistrictType';
import { Typography } from '@mui/material';
import React from 'react';

interface Props {
  row: RequireItemList;
}
export default function CreaterNameColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{row.createrName}</Typography>;
}
